import React, { useEffect, useState } from 'react'
import { CAlert, CButton, CForm, CFormInput, CFormLabel, CFormTextarea, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react'
import { request } from '../../services'

function AgencyModal({ open, planUuid, onClose, onCreated }) {
  const [form, setForm] = useState({ uuid: '', name: '', parent_pcc: '', description: '' })
  const [error, setError] = useState('')
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    if (open) setForm((current) => ({ ...current, uuid: planUuid || current.uuid }))
  }, [open, planUuid])

  async function submit(event) {
    event.preventDefault()
    setSaving(true)
    setError('')
    const res = await request('create_agency', { method: 'POST', body: form })
    setSaving(false)
    if (!res.ok) {
      setError(res.data?.error || Object.values(res.data?.errors || {})[0] || 'No se pudo crear la agencia')
      return
    }
    onCreated()
  }

  return (
    <CModal visible={open} onClose={onClose}>
      <CForm onSubmit={submit}>
        <CModalHeader><CModalTitle>Crear agencia</CModalTitle></CModalHeader>
        <CModalBody>
          {error ? <CAlert color="danger">{error}</CAlert> : null}
          {planUuid ? null : (
            <div className="mb-3"><CFormLabel>UUID plan disponible</CFormLabel><CFormInput value={form.uuid} onChange={(event) => setForm({ ...form, uuid: event.target.value })} required /></div>
          )}
          <div className="mb-3"><CFormLabel>Nombre</CFormLabel><CFormInput value={form.name} onChange={(event) => setForm({ ...form, name: event.target.value })} required /></div>
          <div className="mb-3"><CFormLabel>Parent PCC</CFormLabel><CFormInput value={form.parent_pcc} maxLength={4} onChange={(event) => setForm({ ...form, parent_pcc: event.target.value.toUpperCase() })} required /></div>
          <div className="mb-3"><CFormLabel>Descripcion</CFormLabel><CFormTextarea value={form.description} onChange={(event) => setForm({ ...form, description: event.target.value })} /></div>
        </CModalBody>
        <CModalFooter>
          <CButton color="light" onClick={onClose}>Cancelar</CButton>
          <CButton color="success" className="btn-brand" type="submit" disabled={saving}>Crear</CButton>
        </CModalFooter>
      </CForm>
    </CModal>
  )
}

export default AgencyModal
